import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import EntryScreen from '../EntryScreen';
import LandingPage from '../LandingMiD';
import LandingHome from './LandingHome';

import { loadPublicFlags, readCachedPublicFlags } from '../../lib/publicFlags';

let refreshAfterTimeout = false;

// React has not committed yet when state initialises, so the prerendered HTML is still in #root.
const hasPrerenderedLanding = () => Boolean(document.querySelector('#root [data-testid="landing-home"]'));
// The build only prerenders the landing when it is on. The chat waits for the real answer.
const PRERENDERED_FLAGS = { landing_v2: true, landing_chat: false, buyer_profile_v2: false };

export default function LandingRoute({ about = false }) {
  const { user, isAuthenticated } = useAuth();
  const [prerendered] = useState(hasPrerenderedLanding);
  const [flags, setFlags] = useState(() => readCachedPublicFlags() ?? (prerendered ? PRERENDERED_FLAGS : null));
  // Signed-in buyers stay on the landing ("Ir para o meu mapa" in its header, onep.20); EntryScreen still redirects them.
  let redirectPath;
  if (!about && isAuthenticated && user?.user_type === 'agent') redirectPath = '/agent/dashboard';
  else if (!about && isAuthenticated && user?.user_type === 'admin') redirectPath = '/admin';

  useEffect(() => {
    if (redirectPath) return;
    let mounted = true;
    let timer;
    const request = loadPublicFlags(refreshAfterTimeout);
    refreshAfterTimeout = false;
    const deadline = new Promise((resolve) => {
      timer = setTimeout(() => {
        refreshAfterTimeout = true;
        resolve(readCachedPublicFlags() ?? (prerendered ? PRERENDERED_FLAGS : { landing_v2: false, landing_chat: false, buyer_profile_v2: false }));
      }, 1500);
    });
    Promise.race([request, deadline])
      .then((loaded) => { if (mounted && !(prerendered && loaded.failed)) setFlags(loaded); })
      .finally(() => clearTimeout(timer));
    return () => { mounted = false; clearTimeout(timer); };
  }, [redirectPath, prerendered]);

  if (redirectPath) return <Navigate to={redirectPath} replace />;
  if (flags === null) {
    return <div data-testid="landing-flags-pending" className="landing-flags-pending" style={{
      minHeight: '100vh', backgroundColor: '#0a0c14',
      backgroundImage: 'radial-gradient(ellipse 80% 60% at 50% -10%, color-mix(in srgb, var(--brand-primary, #A78BD9) 14%, transparent), transparent)',
    }} />;
  }
  const enabled = flags.landing_v2 === true;
  if (about) return enabled ? <Navigate to="/" replace /> : <LandingPage />;
  return enabled ? <LandingHome landingChatEnabled={flags.landing_chat === true} /> : <EntryScreen />;
}
